import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, MessageCircle, Download } from "lucide-react";
import { Logo } from "./Logo";

const GUIDE_PDF = "/guida-tutorial-pushapp.pdf";

export const Footer = () => {
  return (
    <footer className="bg-brand-deep text-white" data-testid="main-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="inline-flex rounded-2xl bg-white/10 p-3">
              <Logo />
            </div>
            <p className="mt-4 font-body text-white/70 leading-relaxed max-w-xs">
              Il tuo canale diretto con i clienti — e il centro guida per usarlo al meglio.
            </p>
            <a
              href={GUIDE_PDF}
              download
              target="_blank"
              rel="noreferrer"
              data-testid="footer-download-guide"
              className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-2.5 font-body font-semibold text-white text-sm transition-colors hover:bg-white/20"
            >
              <Download size={16} strokeWidth={2.5} /> Scarica guida tutorial
            </a>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white">Per chi ha già l'app</h4>
            <ul className="mt-4 space-y-2.5">
              {[["Guide", "/guide"], ["Strategie", "/strategie"], ["Notifiche pronte", "/notifiche"], ["Errori & Checklist", "/checklist"]].map(([label, to]) => (
                <li key={to}>
                  <Link to={to} className="font-body text-white/70 hover:text-white transition-colors" data-testid={`footer-link-${to.replace("/", "")}`}>{label}</Link>
                </li>
              ))}
            </ul>
            <h4 className="mt-6 font-heading font-semibold text-white">Risorse</h4>
            <ul className="mt-4 space-y-2.5">
              <li><Link to="/faq" className="font-body text-white/70 hover:text-white transition-colors">FAQ</Link></li>
              <li><Link to="/assistenza" className="font-body text-white/70 hover:text-white transition-colors">Assistenza</Link></li>
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-heading font-semibold text-white">Contatti</h4>
            <ul className="mt-4 space-y-3.5 font-body text-white/75">
              <li className="flex items-start gap-3">
                <MapPin size={18} className="mt-0.5 flex-none text-brand-light" strokeWidth={2.5} />
                <span><b className="text-white">Hub:</b> Via Cosimo del Fante, 16 — Legnano (MI)<br /><b className="text-white">Sede legale:</b> Via I. Bossi, 46 — Rescaldina (MI)</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="flex-none text-brand-light" strokeWidth={2.5} />
                <a href="mailto:info@pushapp.it" className="hover:text-white transition-colors">info@pushapp.it</a>
              </li>
              <li className="flex items-center gap-3">
                <MessageCircle size={18} className="flex-none text-brand-green" strokeWidth={2.5} />
                <a href="https://wa.me/393923875279" target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="hover:text-white transition-colors">Tel / WhatsApp: 392 387 5279</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="flex-none text-brand-light" strokeWidth={2.5} />
                <a href="tel:+390331588546" className="hover:text-white transition-colors">Tel: 0331 1588546</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col gap-2">
          <p className="font-body text-sm text-white/70">
            <b className="text-white">Am Partners Srl</b> &nbsp;|&nbsp; PEC: ampartners.srl@pec.it &nbsp;|&nbsp; P.IVA 06087680960 &nbsp;|&nbsp; REA: MI – 1869668 &nbsp;|&nbsp; Capitale sociale: 10.000,00€
          </p>
          <p className="font-body text-sm text-white/50">© {new Date().getFullYear()} PushApp — Am Partners Srl. Tutti i diritti riservati.</p>
        </div>
      </div>
    </footer>
  );
};
